import { formatBusinessDate, toBusinessWallDate } from '../utils/businessTime';
// Display formatting only. Keep identifiers and persisted form values unchanged.
export const EMPTY = '\u2014'
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const replacements = { '\u00c6': 'Ae', '\u00e6': 'ae', '\u0152': 'Oe', '\u0153': 'oe', '\u00d8': 'O', '\u00f8': 'o', '\u0141': 'L', '\u0142': 'l', '\u0110': 'D', '\u0111': 'd', '\u00d0': 'D', '\u00f0': 'd', '\u00de': 'Th', '\u00fe': 'th', '\u00df': 'ss', '\u1e9e': 'SS', '\u0131': 'i' }
export const stripAccents = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00c6\u00e6\u0152\u0153\u00d8\u00f8\u0141\u0142\u0110\u0111\u00d0\u00f0\u00de\u00fe\u00df\u1e9e\u0131]/g, letter => replacements[letter])
export const formatName = value => stripAccents(value).toLowerCase().replace(/(^|[\s\-'\u2019])(\S)/g, (_, separator, letter) => separator + letter.toUpperCase())
export const normalizeSearch = value => stripAccents(value).toLowerCase()
export const formatEmail = value => String(value ?? '').trim().toLowerCase() || EMPTY
export function formatPhone(value) {
    const raw = String(value ?? '').trim()
    if (!raw) return EMPTY
    let digits = raw.replace(/\D/g, '')
    if (/^61\d{9}$/.test(digits)) digits = '0' + digits.slice(2)
    if (/^04\d{8}$/.test(digits)) return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`
    if (/^0[2378]\d{8}$/.test(digits)) return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`
    return raw
}
export const formatNumber = value => Number(value || 0).toLocaleString('en-AU')
export const formatHours = value => Number(value || 0).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' hrs'
export function formatTime(value) {
    const date = toBusinessWallDate(value)
    if (!date) return EMPTY
    if (Number.isNaN(date.getTime())) return EMPTY
    return `${date.getHours() % 12 || 12}:${String(date.getMinutes()).padStart(2, '0')} ${date.getHours() < 12 ? 'AM' : 'PM'}`
}
export const formatMonth = key => { const [year, month] = String(key).slice(0, 7).split('-'); return MONTHS[Number(month) - 1] ? `${MONTHS[Number(month) - 1]} ${year}` : EMPTY }

export function formatDate(value, pattern = 'd MMM yyyy', options = {}) {
    const date = toBusinessWallDate(value)
    if (!date) return EMPTY
    const fixedPattern = pattern.replace(/'(?:[^']|'')*'|M+/g, token => token === 'MMM' ? "'" + MONTHS[date.getMonth()] + "'" : token)
    return formatBusinessDate(value, fixedPattern, options)
}

export function formatExportRows(rows) {
    const headings = rows[0] || []
    return rows.map((row, index) => index === 0 ? row : row.map((value, column) => /^(worker(?: name)?|employee(?: name)?|first name|last name|user(?: name)?|contact name|team member|recorded by|sent by)$/i.test(String(headings[column] || '').trim()) ? formatName(value) : value))
}
